import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { achievementCategories } from '@/data/achievements';
import GolfIcon from '../GolfIcon';
import { ProgressCircle } from '../ui/progress-circle';

interface UserAchievementsPreviewProps {
  limit?: number;
}

export const UserAchievementsPreview: React.FC<UserAchievementsPreviewProps> = ({
  limit = 3
}) => {
  const { t } = useTranslation('MGP');
  const history = useHistory();

  // Get all earned achievements from all categories
  const earnedAchievements = achievementCategories
    .flatMap(category => category.achievements)
    .filter(achievement => achievement.earned)
    // Sort by earned date (most recent first)
    .sort((a, b) => {
      if (!a.earnedDate) return 1;
      if (!b.earnedDate) return -1;
      return new Date(b.earnedDate).getTime() - new Date(a.earnedDate).getTime();
    })
    // Limit to the specified number
    .slice(0, limit);

  if (earnedAchievements.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col bg-card">
      <button
        className="flex items-center justify-between p-4"
        onClick={() => history.push('/achievements')}
      >
        <div className="flex items-center space-x-3">
          <div className="flex items-center justify-center">
            <GolfIcon name="trophy" className="text-primary size-6" />
          </div>
          <span>{t('trophies')}</span>
        </div>
        <GolfIcon name="chevron-right" className="text-muted-foreground" />
      </button>

      <div className="flex items-center justify-between p-4">
        <div className="flex items-center space-x-4 w-full justify-around">
          {earnedAchievements.map((achievement) => (
            <div key={achievement.id} className="flex flex-col items-center">
              <div className="mb-2">
                <ProgressCircle
                  value={achievement.progress || 0}
                  max={achievement.total || 100}
                  radius={24}
                  strokeWidth={3}
                  variant="default"
                  className="w-12 h-12"
                >
                  <div className="relative">
                    <img
                      src={`/assets/images/badges/${achievement.icon}.webp`}
                      alt={achievement.icon}
                      className="size-6"
                    />
                  </div>
                </ProgressCircle>
              </div>
              <span className="text-xs text-center">{achievement.title}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
